import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import "../index.css"
import Item from '../components/Item';
import ProductAPI from '../services/API';

const Shop = () => {
  const { category } = useParams();
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedType, setSelectedType] = useState('all');

  useEffect(() => {
    if (category) {
      const formattedCategory = category
        .split('-')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
      setSelectedType(formattedCategory);
    }
  }, [category]);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const data = await ProductAPI.getAllProducts();
        setProducts(data);
        setLoading(false);
      } catch (err) {
        console.error("Error fetching products:", err);
        setError("Failed to load products");
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  const productTypes = [
    { display: 'All', value: 'all' },
    { display: 'Custom', value: 'Custom' },
    { display: 'Ancient Coin Pendants', value: 'Ancient Coin Pendant' },
    { display: 'Necklaces', value: 'Necklace' },
    { display: 'Bracelets', value: 'Bracelet' },
    { display: 'Rings', value: 'Ring' },
    { display: 'Earrings', value: 'Earring' },
    { display: 'Other', value: 'Other' }
  ];

  const handleTypeChange = (type) => {
    if (type.value === 'Custom') {
      window.location.href = '/heirloom';
      return;
    }
    
    setSelectedType(type.value);
    if (type.value === 'all') {
      navigate('/shop');
    } else {
      const urlFriendlyType = type.value.toLowerCase().replace(/\s+/g, '-');
      navigate(`/shop/${urlFriendlyType}`);
    }
  };

  const filteredProducts = selectedType === 'all'
    ? products
    : products.filter(product => product.type === selectedType);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <div className="max-w-7xl mx-auto p-8">
      <div className="mb-6 flex flex-wrap gap-2">
        {productTypes.map(type => (
          <button
            key={type.value}
            onClick={() => handleTypeChange(type)}
            className={`px-4 py-2 custom-font-text text-lg ${
              selectedType === type.value
                ? 'text-[#D4AF37] underline underline-offset-4'
                : 'hover:text-accent'
            }`}
          >
            {type.display}
          </button>
        ))}
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {filteredProducts.map((product) => (
          <Item
            key={product.id}
            id={product.id}
            image={product.photos?.[0]}
            type={product.type}
            title={product.name}
            price={product.price}
          />
        ))}
      </div>
    </div>
  );
};

export default Shop;
